import React, { Component } from 'react'
import { Routes, Route,BrowserRouter } from "react-router-dom"
import Home from "../pages/home/HomeComponent";
import Test from '../pages/test';
import EducationPage from "../pages/education/EducationComponent"
import Contact from '../pages/contact/contact';
import Projects from '../pages/projects/Projects';
import Experience from '../pages/experience/Experience';
import Skills from '../pages/skills/skills';
import OpenSource from '../pages/openSource/openSource.tsx';
// import Error404 from "../pages/errors/error404/Error";
import Helmet from 'react-helmet'

export default class Main extends Component {
  
  render() {

      return (
        <div>
          <BrowserRouter>
          <Helmet>
            <html lang="en" />
            <title>Gopal Goyal — AI Engineer & Full-Stack Developer</title>
            <meta name='description'
            content='Gopal Goyal — Founding Engineer at HiRobin and AI & Full-Stack Engineer specialising in AI voice agents, agentic RAG systems, LLMs, and scalable cloud backends on AWS. IIT Bombay alumnus.'/>
            <meta name='keywords' content='Gopal Goyal, AI Engineer, Full-Stack Developer, Founding Engineer, HiRobin, Agentic RAG, AI Voice Agents, LLM, OpenAI, FastAPI, ReactJS, Node.js, AWS, IIT Bombay'/>
            <link rel="canonical" href="https://gopalgoyal.in/" />
            <meta property="og:title" content="Gopal Goyal — AI Engineer & Full-Stack Developer" />
            <meta property="og:description" content="Founding Engineer at HiRobin. AI & Full-Stack Engineer building AI voice agents, agentic RAG systems, and scalable cloud backends." />
            <meta property="og:image" content="https://gopalgoyal.in/profile.jpg" />
            <meta property="og:url" content="https://gopalgoyal.in/" />
          </Helmet>
         <Routes>
        <Route path="/" element={ <Home/> } />
        <Route path="/home" element={ <Home/> } />
        <Route path="/test" element={ <Test/> } />
        <Route path="/education" element={ <EducationPage/> } />
        <Route path="/contact" element={ <Contact/> } />
        <Route path="/projects" element={ <Projects/> } />
        <Route path="/experience" element={ <Experience/> } />
        <Route path="/skills" element={ <Skills/> } />
        <Route path="/opensource" element={ <OpenSource/> } />

        </Routes>
        </BrowserRouter>
        </div>
      );
    
    }
  
}


